import React, { useState } from "react";
import Header from "./Header";
import GenericTable from "../GenericTable";

const OCR = () => {
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [hasNextPage, setHasNextPage] = useState(true);

  const [tableData, setTableData] = useState([
    { sourceFile: null, targetFile: null },
    { sourceFile: null, targetFile: null },
    { sourceFile: null, targetFile: null },
  ]);

  // ✅ Handle file uploads
  const handleFileUpload = (index, fileType, file) => {
    const updatedData = [...tableData];
    if (fileType === "source") {
      updatedData[index].sourceFile = file;
    } else {
      updatedData[index].targetFile = file;
    }
    setTableData(updatedData);
  };

  const fileColumns = [
    {
      header: "Sr. No.",
      cell: ({ row }) => pageIndex * pageSize + row.index + 1,
    },
    {
      header: "Source File (Image / PDF / Word)",
      accessorKey: "sourceFile",
      cell: ({ row }) => {
        const { sourceFile } = row.original;
        return (
          <div className="flex flex-col items-center gap-2">
            <label className="px-4 py-2 bg-[#ec7026] text-white rounded-lg font-medium cursor-pointer hover:bg-orange-600 transition-all duration-200">
              Upload Source
              <input
                type="file"
                accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                className="hidden"
                onChange={(e) =>
                  handleFileUpload(row.index, "source", e.target.files[0])
                }
              />
            </label>
            {sourceFile && (
              <span className="text-sm text-gray-700 font-medium">
                📄 {sourceFile.name}
              </span>
            )}
          </div>
        );
      },
    },
    {
      header: "Target File (JSON)",
      accessorKey: "targetFile",
      cell: ({ row }) => {
        const { targetFile } = row.original;
        return (
          <div className="flex flex-col items-center gap-2">
            <label className="px-4 py-2 bg-blue-600 text-white rounded-lg font-medium cursor-pointer hover:bg-blue-700 transition-all duration-200">
              Upload JSON
              <input
                type="file"
                accept=".json"
                className="hidden"
                onChange={(e) =>
                  handleFileUpload(row.index, "target", e.target.files[0])
                }
              />
            </label>
            {targetFile && (
              <span className="text-sm text-gray-700 font-medium">
                🧾 {targetFile.name}
              </span>
            )}
          </div>
        );
      },
    },
    {
      header: "Actions",
      cell: ({ row }) => (
        <div className="flex justify-center">
          <button
            onClick={() => console.log("Committed:", tableData[row.index])}
            className="px-4 py-1.5 rounded-md text-sm font-semibold text-white bg-green-600 hover:bg-green-700 
              shadow-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-green-400"
          >
            Commit
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="bg-[#fffaf7] min-h-screen relative">
      <Header />
      <div className="bg-white shadow-lg rounded-2xl p-3 w-full max-w-7xl mt-6 mx-auto">
        <div className="flex items-center justify-between mb-5">
          <h2 className="text-xl font-semibold text-gray-800">
            OCR Data Upload Dashboard
          </h2>

          <div className="flex gap-3 items-center">
            <button
              className="px-4 py-2 bg-green-600 text-white rounded-lg font-medium text-sm shadow-sm 
              hover:bg-green-700 focus:ring-2 focus:ring-green-400 transition-all duration-200"
            >
              Pull More
            </button>

            <select
              className="px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-700 font-medium text-sm
                hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-400 cursor-pointer transition-all duration-200"
              defaultValue="English"
              onChange={(e) => console.log("Selected language:", e.target.value)}
            >
              <option value="English">English</option>
              <option value="Hindi">Hindi</option>
              <option value="Gujarati">Gujarati</option>
              <option value="Bengali">Bengali</option>
              <option value="Tamil">Tamil</option>
              <option value="Telugu">Telugu</option>
              <option value="Kannada">Kannada</option>
              <option value="Marathi">Marathi</option>
              <option value="Punjabi">Punjabi</option>
              <option value="Malayalam">Malayalam</option>
            </select>
          </div>
        </div>

        {/* Table Section */}
        <div className="border border-gray-200 rounded-xl">
          <GenericTable
            data={tableData}
            columns={fileColumns}
            showPagination={true}
            manualPagination={true}
            pageIndex={pageIndex}
            pageSize={pageSize}
            hasNextPage={hasNextPage}
            onPaginationChange={({ pageIndex, pageSize }) => {
              setPageIndex(pageIndex);
              setPageSize(pageSize);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default OCR;
